import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DictionaryFuelFeeRecord } from '../types/dictionary-fuelfee-record';
import { DictionaryFuelFeeAddRequest } from '../types/dictionary-fuelfee-add-request';

@Injectable({
  providedIn: 'root',
})
export class DictionaryFuelFeeService {
  private url: string = '/api/dictionary/fuel-fee';

  constructor(private http: HttpClient) {}

  getAll(): Observable<DictionaryFuelFeeRecord[]> {
    return this.http.get<DictionaryFuelFeeRecord[]>(this.url);
  }

  add(parameter: DictionaryFuelFeeAddRequest): Observable<any> {
    return this.http.post<any>(this.url, parameter);
  }

  delete(id: number): Observable<any> {
    const parameter = { id: id };
    return this.http.delete<any>(this.url, { body: parameter });
  }
}
